/* Explore the collection: swap print groups when the PDP Color / Print variant changes. */
class LcCompleteCollection extends HTMLElement {
  connectedCallback() {
    this.groups = Array.from(this.querySelectorAll('[data-lc-complete-group]'));
    this.map = {};
    var mapEl = this.querySelector('[data-lc-complete-map]');
    if (mapEl) {
      try {
        this.map = JSON.parse(mapEl.textContent || '{}');
      } catch (error) {
        this.map = {};
      }
    }

    if (!this.groups.length) {
      this.hidden = true;
      return;
    }

    var selectedKey = '';
    this.groups.forEach(function (group) {
      if (!group.hidden) selectedKey = group.getAttribute('data-print-key') || '';
    });
    this.applyKey(selectedKey);

    this.unsubscribe = null;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant.bind(this));
    }
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === 'function') this.unsubscribe();
  }

  onVariant(event) {
    var variant = event && event.data && event.data.variant;
    if (!variant) return;
    var key = this.map[String(variant.id)] || '';
    this.applyKey(key);
  }

  applyKey(key) {
    var any = false;
    var intro = null;
    this.groups.forEach(function (group) {
      var on = Boolean(key) && group.getAttribute('data-print-key') === key;
      group.hidden = !on;
      if (on) {
        any = true;
        intro = group.querySelector('.lc-complete__intro');
      }
    });
    this.hidden = !any;
    if (intro) intro.setAttribute('data-lc-complete-intro', '');
  }
}

if (!customElements.get('lc-complete-collection')) {
  customElements.define('lc-complete-collection', LcCompleteCollection);
}
